import factory from '@/api/factory'

export async function apis (platform, internalToken) {
  const route = platform.storeData.config.globals.routes.apis

  platform.fetch.auth = internalToken

  const res = await platform.fetch(`https://${platform.router.host}${route}`)

  delete platform.fetch.auth

  await factory.maybeThrowAPIError(res, route)

  return res.json()
}

export async function commonName (platform) {
  const route = platform.storeData.config.globals.routes.commonName
  const res = await platform.fetch(`https://${platform.router.host}${route}`)

  await factory.maybeThrowAPIError(res, route)

  const data = await res.json()

  return data.name
}
